export const SERVICE_UNAVAILABLE_ERROR = {
    general: 'Le service de commande est temporairement indisponible. Veuillez réessayer plus tard',
};

export const getErrorData = (error) => (
    error && error.response && error.response.data
        ? error.response.data
        : SERVICE_UNAVAILABLE_ERROR
);

export const getErrorStatus = (error) => (
    error && error.response ? error.response.status : undefined
);
